import { ABaseModel } from '../abstracts/ABaseModel.js';
import { IMe, IMeUser, IMeVisitor, IMeSeller, IMeArtist, IMePartner, IMeAdmin } from '../interfaces/Me.js';
import { Image } from './Image.js';
import { PrivacySetting } from './User.js';
import { EmailSubscription } from './Email.js';

/**
 * MeUser
 */
class MeUser extends ABaseModel implements IMeUser {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  role: string;
  lastLogin: string;
  registrationDate: string;
  city: string;
  phone: string;
  birthDate: string;
  ageRange: string;
  gender: string;
  timeZone: string;
  quizDate: string;
  quizPersonality: string;
  countryCode: string;
  customerCreditValue: number;
  customerCreditCurrency: string;
  avatars: Array<Image>;
  privacySettings: Array<PrivacySetting>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * Visitor
 */
class MeVisitor extends ABaseModel implements IMeVisitor {
  id: number;
  created: string;
  autoLogin: boolean;
  cohort: string;
  language: string;
  locale: string;
  role: string;
  email: string;
  ipAddress: string;
  userAgent: string;
  unitSystem: string;
  unitLength: string;
  unitWeight: string;
  isUser: boolean;
  isCustomer: boolean;
  storeCode: string;
  countryCode: string;
  shippingCountryCode: string;
  cartQty: number;
  cartCurrencyCode: string;
  cartTotal: number;
  emailSubscriptions?: Array<EmailSubscription>;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * MeSeller
 */
class MeSeller extends ABaseModel implements IMeSeller {
  id: number;
  type: number;
  name: string;
  entityRole: string;
  entityId: number;
  integrationId: number;
  onboardingStage: number;
  currencyCode: string;
  storeCode: string;
  language: string;
  locale: string;
  shipsCountryCode: string;
  canRentArt: boolean;
  canUseShippingTables: boolean;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * MeArtist
 */
class MeArtist extends ABaseModel implements IMeArtist {
  id: number;
  alias: string;
  name: string;
  gender: string;
  commissions: boolean;
  birthYear: number;
  birthCity: string;
  birthCountryCode: string;
  livesCity: string;
  livesCountryCode: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * MePartner
 */
class MePartner extends ABaseModel implements IMePartner {
  id: number;
  name: string;
  type: string;
  email: string;
  phone: string;
  city: string;
  postCode: string;
  countryCode: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * MeAdmin
 */
class MeAdmin extends ABaseModel implements IMeAdmin {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  lastLogin: string;
  workTitle: string;
  workCompany: string;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

/**
 * Me
 */
class Me extends ABaseModel implements IMe {
  id: string;
  visitor?: MeVisitor;
  user?: MeUser;
  seller?: MeSeller;
  artist?: MeArtist;
  partner?: MePartner;
  admin?: MeAdmin;

  /**
   * Constructor
   */
  constructor() {
    super();
  }
}

export { Me, MeUser, MeVisitor, MeSeller, MeArtist, MePartner, MeAdmin };
